import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { ReactNode } from 'react';
import Button from '../Button/Button';

const { Title, Paragraph } = Typography;

type CustomCardProps = {
  title: string;
  content: ReactNode;
  buttonText: string;
  onButtonClick: () => void;
  buttonDisabled?: boolean;
};

const CustomCard = ({ title, content, buttonText, onButtonClick, buttonDisabled = false }: CustomCardProps) => {
  return (
    <Card
      style={{ width: '100%', borderRadius: 4, overflow: 'hidden', maxWidth: '544px' }}
      bodyStyle={{ display: 'flex', flexDirection: 'column', padding: 0 }}
    >
      <Row style={{ display: 'flex', flexDirection: 'column' }}>
        <Col style={{ padding: '24px 32px' }}>
          <Title level={2} style={{ marginBottom: 0 }}>
            {title}
          </Title>
        </Col>
        <Col style={{ padding: '8px 32px 24px 32px' }}>
          <Paragraph type="secondary" style={{ flexGrow: 1, marginBottom: 0 }}>
            {content}
          </Paragraph>
        </Col>
        <Col style={{ padding: '24px 32px', borderTop: '1px solid #f0f0f0', background: '#fafafa' }}>
          <Button type="primary" onClick={onButtonClick} disabled={buttonDisabled} block>
            {buttonText}
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default CustomCard;
